import { MijnRoute } from '../../mijn-navigatie.model';

export const LOAN_APPLY_MANAGE: MijnRoute = {
    path: 'leningen-aanvragen/beheer',
    navigationEvent: 'toLenenBeheer',
    regex: /^\/leningen-aanvragen\/beheer$/,
    webcomponent: 'mijn-leningen-aanvragen-webcomponent',
    internalPath: 'beheer'
};
